import { FunnelStage } from "models/opportunity-dashboard"
import { money } from "./format"

interface SalesFunnelChartProps {
    stages: FunnelStage[]
}

// Bar colour per stage: early stages (blue zone), proposal stages (yellow zone), Won.
const stageColor = (stage: string) => {
    const s = stage.toLowerCase()
    if (s.startsWith("identified") || s.startsWith("engaged")) return "var(--bs-primary)"
    if (s.startsWith("won")) return "var(--bs-success)"
    return "var(--bs-warning)"
}

// Centred bars, widest at the largest stage value, like the Power BI funnel visual.
const SalesFunnelChart = ({ stages }: SalesFunnelChartProps) => {
    const max = Math.max(...stages.map(s => s.value), 0)

    return <div className="sales-funnel">
        {stages.map(s => {
            const width = max > 0 ? Math.max((s.value / max) * 100, 2) : 2
            return <div className="sales-funnel-row" key={s.stage}>
                <div className="sales-funnel-label">{s.stage} ({Math.round(s.weight * 100)}%)</div>
                <div className="sales-funnel-track">
                    <div
                        className="sales-funnel-bar"
                        style={{ width: `${width}%`, background: stageColor(s.stage) }}
                        title={`${s.stage}: ${money(s.value)} (${s.count})`}
                    />
                </div>
                <div className="sales-funnel-value">
                    <strong>{money(s.value)}</strong>
                    <small className="text-muted">{s.count} opp.</small>
                </div>
            </div>
        })}
    </div>
}

export default SalesFunnelChart
